export const operationLeftPanelWidth = 400;
export const quantityColumnWidth = 75;
